import { getDefaultErrorMessage } from 'utils/axios';

import {
  ACTIVATION_CODE_QUERY_PARAM,
  ACTIVATION_REQUEST_ID_QUERY_PARAM,
  USE_PASSWORD_TO_SIGN_IN_MESSAGE,
} from './Login.constants';

/* DEV-4179: Parses the invite-activation query params out of a URL search string.
   The backend encodes the activate link as:
     https://{sub-company-domain}?requestId={id}&code={code}
   Returns { requestId, code } when BOTH params are present, null otherwise. */
export const parseActivationParamsFromSearch = search => {
  const params = new URLSearchParams(search);
  const requestId = params.get(ACTIVATION_REQUEST_ID_QUERY_PARAM);
  const code = params.get(ACTIVATION_CODE_QUERY_PARAM);

  if (!requestId || !code) {
    return null;
  }

  return { requestId, code };
};

export const isUsePasswordToSignInError = error => {
  if (!error?.response) {
    return false;
  }

  return [getDefaultErrorMessage(error)].flat().includes(USE_PASSWORD_TO_SIGN_IN_MESSAGE);
};
